/* eslint-disable import/no-extraneous-dependencies */

import Admin from 'hive-admin';

import getFilterWithCol from '../../../helpers/getFilterWithCol';

// import Types from '../../../common/modules/types';

const isNotParallax = Admin.compileFromLibrary([
  'condition.testFieldValue',
  'type',
  '!==',
  'PARALLAX',
]);

export default [
  ...[
    ['FieldRadio', {
      label: null,
      name: 'parallax_trigger',
      initialValue: 'SCROLL',
      block: true,
      choices: ['Scroll', 'Mouse', 'Both'].map(label => ({
        value: label.toUpperCase(),
        label,
      })),
    }],
    getFilterWithCol(['FieldText', {
      label: null,
      name: 'parallax_depth',
      prefix: 'Depth:',
      align: 'right',
    }], 24),
  ].map(([fieldType, fieldConfig]) => Admin.compileFromLibrary([
    fieldType,
    {
      ...fieldConfig,
      preSkip: [isNotParallax, ...(fieldConfig.preSkip || [])],
    },
  ])),
];
